'use client';

import type { CsnSearchVenue } from '@/models/CsnSearchVenue';

type Props = {
  venue: CsnSearchVenue;
};

const debugPrefix = '(Debug)';

// Prepares a row for Distance
function getDistanceRow(venue: CsnSearchVenue): JSX.Element | null {
  if (venue?.distanceFromSearchLocation) {
    return (
      <li>
        <div>
          {`${debugPrefix} Distance: ${venue.distanceFromSearchLocation.imperialValue?.toFixed(
            1
          )} mi. or ${venue.distanceFromSearchLocation.metricValue?.toFixed(1)} km`}
        </div>
      </li>
    );
  }
  return null;
}

// Renders debug information
export default function DebugDetail({ venue }: Props): JSX.Element {
  return (
    <div className="rounded-xl bg-background px-4 py-2 text-b-xs">
      <ul>
        {getDistanceRow(venue)}
        <li>
          <div>{`${debugPrefix} Diamond Level: ${venue.diamondLevel}`}</div>
        </li>
        <li>
          <div>{`${debugPrefix} MMA: ${venue.metroAreaName ? venue.metroAreaName : ''}`}</div>
        </li>
        <li>
          <div>{`${debugPrefix} Location: (${venue.geographicLocation?.lat} lat, ${venue.geographicLocation?.lon} lon)`}</div>
        </li>
      </ul>
    </div>
  );
}
